import AdvertiseManagement from "./advertise-management.page";

export default AdvertiseManagement;
